export const resources = {
  en: {
    translation: {
      home: "Home",
      about: "About",
      workout: "Workout",
      trainings: "Trainings",
      Onlinecourses: "Online Courses",
      athletes: "Athletes",
      shop: "Shop",
      blogs: "Blogs",
      contact: "Contact",
      profile: "Profile",
      logOut: "Log out",
      getInTouch: "Get In Touch",
      name: "Name",
      email: "Email",
      message: "Message",
      sendMessage: "Send Message",
      send: "Send",
      contactInformation: "Contact Information",
      giorgitsminda: "Giorgitsminda",
      SagarejoGeorgia3800: "Sagarejo, Georgia, 3800",
      phone: "Phone",
      ourLocation: "Our Location",
      contactUs: "Contact Us",
      followUs: "Follow Us",
      wellcomeToOur: "Wellcome To Our",
      armwrestling: "ARMWRESTLING",
      club: "Club",
      readMore: "Read More",
      showLess: "Show Less",
      OurClubsAchievements: "Our Club's Achievements",
      world: "World",
      europe: "Europe",
      georgia: "Georgia",
      total: "Total",
      login: "Log In",
      password: "Password",
      confirmPassword: "Confirm Password",
      confirmYourPassword: "Confirm Your Password",
      dontHaveAccount: "Don't have an account?",
      alreadyHaveAccount: "Already have an account?",
      signUp: "Sign Up",
      cancel: "Cancel",
      areYouSure: "Are You Sure?",
      forgetPassword: "Forget Password?",
      reset: "Reset",
      resetPassword: "Reset Password",
      rememberPassword: "Remember Password?",
      setNewPassword: "Set New Password",
      newPassword: "New Password",
      passwordsDoNotMatch: "Passwords do not match",
      passwordResetSuccess: "Password has been reset successfully",
      somethingWentWrong: "Something went wrong. Check the connection!",
      textForAboutPage:
        "Our club is more than just a gym—it's a community built on passion, strength, and shared determination. Here, we aren't just training; we're transforming. Every day, we come together to inspire, challenge, and empower each other to reach new levels of success—both on and off the arm wrestling table. We provide a space designed to push boundaries and redefine what's possible. With state-of-the-art equipment, personalized arm wrestling training programs, and guidance from world-class coaches, our club is the ultimate destination for those seeking excellence. Whether you're taking your first steps into arm wrestling or you're a seasoned competitor, our supportive and driven community will help you unlock your full potential. Join us and become part of something extraordinary—a club where champions are made and limits are broken.",
      achievementsText:
        "At our club, we don't just train—we rise champions. With a world-class trainers and athletes we provide the perfect space for arm wrestling training and help you to push your limits",
      allRightsReserved: "All rights reserved",
      garejelebi: "GAREJELEBI",
      ArmWrestlingClubGarejelebi: "Arm Wrestling Club Garejelebi",
      getStarted: "Get Started",
      crushYourLimits: "CRUSH YOUR LIMITS",
      crushYourLimitsText:
        "Strength begins in the mind. Arm yourself for victory with focused training",
      powerMeetsTechnic: "POWER MEETS TECHNIQUE",
      powerMeetsTechnicText:
        "Master the balance of strength and strategy to dominate every match",
      masterTheArt: "MASTER THE ART OF ARM WRESTLING",
      masterTheArtText:
        "Discover the secrets of strength and strategy from a proven champion",
      riseTop: "Rise To The Top",
      riseTopText:
        "Train hard, grip stronger, and conquer the table with confidence",
      powerInProgress: "Power in Progress",
      powerInProgressText:
        "Train with purpose, embrace the challenge, and watch your strength soar.",
      termsAndServices: "Terms & Services",
      termsAndConditions: "Terms and Conditions",
      privacyPolicy: "Privacy Policy",
      enterYourEmail: "Enter Your Email",
      enterYourPassword: "Enter Your Password",
      enterYourName: "Enter Your Name",
      enterYourMessage: "Enter Your Message",
    },
  },
  ge: {
    translation: {
      home: "მთავარი",
      about: "შესახებ",
      workout: "ვარჯიშები",
      trainings: "ვარჯიშები",
      athletes: "ათლეტები",
      shop: "მაღაზია",
      blogs: "ბლოგები",
      contact: "კონტაქტი",
      profile: "პროფილი",
      logOut: "გასვლა",
      name: "სახელი",
      email: "ელ-ფოსტა",
      message: "შეტყობინება",
      send: "გაგზავნა",
      sendMessage: "შეტყობინების გაგზავნა",
      contactInformation: "საკონტაქტო ინფორმაცია",
      giorgitsminda: "გიორგიწმინდა",
      SagarejoGeorgia3800: "საგარეჯო, საქართველო, 3800",
      phone: "ტელეფონი",
      ourLocation: "ჩვენი ლოკაცია",
      contactUs: "დაგვიკავშირდით",
      followUs: "გამოგვყევით",
      getInTouch: "მოგვწერეთ",
      wellcomeToOur: "კეთილი იყოს თქვენი მობრძანება ჩვენს",
      armwrestling: "მკლავჭიდის",
      club: "კლუბში",
      readMore: "მეტის ჩვენება",
      showLess: "ნაკლების ჩვენება",
      OurClubsAchievements: "ჩვენი კლუბის მიღწევები",
      world: "მსოფლიო",
      europe: "ევროპა",
      georgia: "საქართველო",
      total: "სულ",
      login: "შესვლა",
      password: "პაროლი",
      confirmPassword: "გაიმეორეთ პაროლი",
      confirmYourPassword: "დაადასტურეთ პაროლი",
      dontHaveAccount: "არ გაქვს ანგარიში?",
      alreadyHaveAccount: "უკვე გაგქვთ ანგარიში?",
      signUp: "რეგისტრაცია",
      cancel: "გაუქმება",
      areYouSure: "დარწმუნებული ხარ?",
      forgetPassword: "დაგავიწყდა პაროლი?",
      reset: "აღდგენა",
      resetPassword: "პაროლის აღდგენა",
      rememberPassword: "გახსოვთ პაროლი?",
      setNewPassword: "ახალი პაროლის დაყენება",
      newPassword: "ახალი პაროლი",
      passwordsDoNotMatch: "პაროლები არ ემთხვევა",
      passwordResetSuccess: "პაროლი წარმატებით შეიცვალა",
      somethingWentWrong: "დაფიქსირდა შეცდომა. შეამოწმეთ კავშირი!",
      textForAboutPage:
        "ჩვენი კლუბი უფრო მეტია, ვიდრე უბრალოდ სპორტული დარბაზი — აქ არის მონდომება, ფიზიკური და სულიერი ძალა და საერთო მიზნები. ჩვენ არა მხოლოდ ვვარჯიშობთ, არამედ ვქმნით საკუთარი თავის საუკეთესო ვერსიას. ყოველდღე ერთად ვიკრიბებით, რათა შთავაგონოთ, გავამხნევოთ და დავეხმაროთ ერთმანეთს ახალი სიმაღლეების მიღწევაში — როგორც ცხოვრებაში, ისე მკლავჭიდის სამყაროში. ჩვენ გთავაზობთ სივრცეს, რომელიც გეხმარებათ საკუთარი შესაძლებლობების მაქსიმალურად გამოვლენაში და ახალი მიზნების მიღწევაში. ჩვენი ვარჯიშის პროგრამები და მაღალი კლასის მწვრთნელები ჩვენს კლუბს განსაკუთრებულს ხდიან. მიუხედავად იმისა, დამწყები სპორტსმენი ხარ თუ გამოცდილი, ჩვენი გუნდი დაგეხმარება შენი სრული პოტენციალის გამოვლენაში. შემოგვიერთდი და გახდი რაღაც განსაკუთრებულის ნაწილი — კლუბი, სადაც იზრდებიან ჩემპიონები და სადაც არ არსებობს გადაულახავი ბარიერი.",

      achievementsText:
        "ჩვენს კლუბში ჩვენ არა მხოლოდ ვვარჯიშობთ, არამედ მომავალ ჩემპიონებს ვქმნით. გარემო, რომელიც უზრუნველყოფს იდეალურ პირობებს ვარჯიშისთვის, ეხმარება სპორტსმენებს გადალახონ შესაძლებლობების საზღვრები",
      allRightsReserved: "ყველა უფლება დაცულია",
      garejelebi: "გარეჯელები",
      ArmWrestlingClubGarejelebi: "მკლავჭიდის კლუბი გარეჯელები",
      getStarted: "დაიწყეთ",
      crushYourLimits: "გადალახე შესაძლებლობის ზღვარი",
      crushYourLimitsText:
        "სიძლიერე იწყება მენტალიტეტით. მოემზადე გამარჯვებისთვის ფიზიკური და მენტალური ვარჯიშებით",
      powerMeetsTechnic: "ძალა და ტექნიკა",
      powerMeetsTechnicText:
        "შექმენი ძალის, ტექნიკისა და ტაქტიკის საუკეთესო კომბინაცია",
      masterTheArt: "შეისწავლე მკლავჭიდის ხელოვნება",
      masterTheArtText: "აღმოაჩინე ძალის, ტექნიკისა და სტრატეგიის სიღრმეები",
      riseTop: "მიაღწიე მწვერვალს",
      riseTopText:
        "დაიხარჯე ბოლომდე, გახდი უფრო ძლიერი და იყავი მაგიდასთან თავდაჯერებული",
      termsAndServices: "წესები & პირობები",
      privacyPolicy: "კონფიდენციალურობის პოლიტიკა",
      termsAndConditions: "წესები და პირობები",
      enterYourEmail: "შეიყვანეთ ელ-ფოსტა",
      enterYourPassword: "შეიყვანეთ პაროლი",
      enterYourName: "შეიყვანეთ სახელი",
      enterYourMessage: "აკრიფეთ შეტყობინება",
    },
  },
};
